import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { NbToastrService, NbDialogService } from '@nebular/theme';
import { SnoozeTimeComponent } from '../components/snooze-time/snooze-time.component';
import { NewReminderModalComponent } from '../components/new-reminder-modal/new-reminder-modal.component';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {

  reminders$ : BehaviorSubject<[]> = new BehaviorSubject<[]>([]);
  reminderUpdated$ : Subject<{}> = new Subject<{}>();

  constructor(
    private http: HttpClient,
    private toasterService: NbToastrService,
    private dialogService:NbDialogService
  ) { }

  times = [
    { label: "5 min", val: 5 },
    { label: "10 min", val: 10 },
    { label: "30 min", val: 30 },
    { label: "1 hour", val: 60 },
    { label: "1 day", val: 1440 },
    { label: "2 days", val: 2880 },
    { label: "3 days", val: 4320 },
    { label: "1 week", val: 10080 },
    { label: "reschedule", val: 'reschedule' },
  ];

  getReminderCount(resourceId? : string){

    let APIEnpoint = `${environment.apiUrl}/reminders/getReminderCount`;
    if(resourceId){
      APIEnpoint = APIEnpoint + '?resourceId='+resourceId;
    }
    return this.http.get(APIEnpoint);
  }

  myReminders(limit, skip = 0, resourceId? : string , overDueReminders? : boolean) {
    if(resourceId){
      return this.http.get(`${environment.apiUrl}/reminders/myReminders?limit=${limit}&skip=${skip}&resourceId=${resourceId}`);
    }else{
      let url = `${environment.apiUrl}/reminders/myReminders?limit=${limit}&skip=${skip}`;
      if(overDueReminders){
        url = url + `&overDueReminders=true`
      }
      return this.http.get(url);
    }
  }

  markComplete(reminder){

    let resource = '';

      if(reminder.reminderDetails._id){
        resource = reminder.reminderDetails._id;
      }

      if(reminder.reminderDetails.notificationId){
        resource = reminder.reminderDetails.notificationId;
      }

      if(!resource && reminder._id){
        resource = reminder._id;
      }

      this.http.put(`${environment.apiUrl}/reminders/update/${resource}`, {
        isCompleted: true,
      }).subscribe(
        (res: any) => {
          if (res.statusCode === 200) {
            this.toasterService.success("","Reminder marked as completed sucessfully!");
          } else {
            this.toasterService.danger(res.message, "Error");
          }
        },
        (error) => {
          this.toasterService.danger('Request failed', "Error");
        }
      )

  }

  openSnoozeModal(reminder,i=0 , ref?) {

    this.dialogService.open(SnoozeTimeComponent, {
      context: {
        times: this.times,
      },
    })
      .onClose.subscribe(val => {
        if (val) {
          if (val == "reschedule") {
            console.log(val,';...val')
            this.openReminderModal(reminder);
          } else {
            this.snooze(reminder,val,i);

          }
          ref.close()
        }
      });
  }

  openReminderModal(reminder) {

    if ((reminder.tableId && reminder.resourceId) ||
      (reminder.reminderDetails?.dateTime && reminder.resourceId)) {
      const ref = this.dialogService.open(NewReminderModalComponent, {
        context: {
          tableId: reminder.tableId ? reminder.tableId : '',
          tableName: reminder.tableId ? reminder.tableName : '',
          resourceId: reminder.resourceId,
          IdFieldData: reminder.tableId ? reminder.toDisplay : '',
          fromViewPage: reminder.tableId ? true : false,
          tableIcon: reminder.tableId && reminder.tableIcon ? reminder.tableIcon[reminder.tableName] : '',
          updateReminder: reminder.tableId ? reminder : reminder.reminderDetails,
        },
      })
        .onClose.subscribe(val => {
          console.log(val,"valvalval")
          if (val == 'Done') {
            // this.ref.close();
          }
        });
    } else {
      const ref = this.dialogService.open(NewReminderModalComponent, {
        context: {
          fromViewPage: false,
          updateReminder: reminder
        },
      })
        .onClose.subscribe(val => {
          if (val == 'Done') {
            // this.ref.close();
          }
        });
      }
  }

  openReminderModal2(reminder): Observable<any> {
    return new Observable<any>(observer => {
      if ((reminder.tableId && reminder.resourceId) || (reminder.reminderDetails?.dateTime && reminder.resourceId)) {
        const ref = this.dialogService.open(NewReminderModalComponent, {
          context: {
            tableId: reminder.tableId ? reminder.tableId : '',
            tableName: reminder.tableId ? reminder.tableName : '',
            resourceId: reminder.resourceId,
            IdFieldData: reminder.tableId ? reminder.toDisplay : '',
            fromViewPage: reminder.tableId ? true : false,
            tableIcon: reminder.tableId && reminder.tableIcon ? reminder.tableIcon[reminder.tableName] : '',
            updateReminder: reminder.tableId ? reminder : reminder.reminderDetails,
          },
        })
        .onClose.subscribe(val => {
          observer.next(val); // Emit the value when the dialog is closed
          observer.complete(); // Complete the observable
        });
      } else {
        const ref = this.dialogService.open(NewReminderModalComponent, {
          context: {
            fromViewPage: false,
            updateReminder: reminder
          },
        })
        .onClose.subscribe(val => {
          observer.next(val); // Emit the value when the dialog is closed
          observer.complete(); // Complete the observable
        });
      }
    });
  }

  getSnoozeTime(snoozeTime){
    let dateVal = new Date();
    return new Date(dateVal.getTime() + snoozeTime * 60000)
  }

  snooze(notification,snoozeTime,i) {

    if (snoozeTime) {

      let snooze = this.getSnoozeTime(snoozeTime);

      let resource = '';

      if(notification.reminderDetails?._id){
        resource = notification.reminderDetails._id;
      }

      if(notification.reminderDetails?.notificationId){
        resource = notification.reminderDetails.notificationId;
      }

      if(!resource){
        resource = notification?._id;
      }

      this.http.put(`${environment.apiUrl}/reminders/update/${resource}`, {
        dueDate: snooze,
      }).subscribe(
        (res: any) => {
          if (res.statusCode === 200) {
            this.toasterService.success(res.message, "Success");
            let reminders:any =  this.reminders$.value;
            const findIndex =  reminders?.findIndex((res) => res?._id == notification?._id)
            reminders[findIndex].dueDate = snooze;
            this.reminders$.next(reminders);
            this.reminderUpdated$.next(reminders[findIndex]);
            return true;
          } else {
            this.toasterService.danger(res.message, "Error");
            return true;
          }
        },
        (error) => {
          return false;
        }
      );
    }else{
      return false;
    }
  }
}
